/* 
 * @Author: 曹俊杰 
 * @Date: 2025年4月9日
 * @Module: 用户的历史记录
 */

const state = () => ({
	userLogList: []
});

const mutations = {
	setUserLog(state, payload) {
		state.userLogList = payload;
	}
};

const actions = {
	saveUserLog({ state, commit }, payload) {
		const list = [...state.userLogList];
		const index = list.findIndex(item => item.uuid === payload.uuid);

		if (index > -1) {
			const oldItem = list[index];
			const updatedItem = {
				...oldItem,
				...payload,
				token: payload.token != null ? payload.token : oldItem.token  // 保留旧 token
			};
			list[index] = updatedItem;
		} else {
			list.push(payload);
		}
		commit('setUserLog', list);
	},

	clearUserLog({ commit }) {
		commit('setUserLog', []);
	},

	deleteUserLog({ state, commit }, payload) {
		const list = state.userLogList.filter(item => item.uuid !== payload.uuid);
		commit('setUserLog', list);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};